import React from 'react'
import { FormattedMessage } from 'react-intl'

export const LANDING_BONUS_FIRST_ITEM_HEADER = (
    <FormattedMessage
        id='landing_bonus.first_item.header'
        defaultMessage='Техника и 3D-стили'
    />
)

export const LANDING_BONUS_SECOND_ITEM_HEADER = (
    <FormattedMessage
        id='landing_bonus.second_item.header'
        defaultMessage='Золото и боны'
    />
)

export const LANDING_BONUS_THIRD_ITEM_HEADER = (
    <FormattedMessage
        id='landing_bonus.third_item.header'
        defaultMessage='Клановые резервы и элементы внешнего вида'
    />
)

export const LANDING_BONUS_FIRST_ITEM_MESSAGE = (
    <FormattedMessage
        id='landing_bonus.first_item.message'
        defaultMessage='Получайте технику, а также особые 3D-стили за победы в событиях на Глобальной карте.'
    />
)

export const LANDING_BONUS_SECOND_ITEM_MESSAGE = (
    <FormattedMessage
        id='landing_bonus.second_item.message'
        // eslint-disable-next-line max-len
        defaultMessage='Зарабатывайте золото в Военных играх, а на Глобальной карте — золото и боны. За них вы сможете купить технику и многое другое.'
    />
)

export const LANDING_BONUS_THIRD_ITEM_MESSAGE = (
    <FormattedMessage
        id='landing_bonus.third_item.message'
        // eslint-disable-next-line max-len
        defaultMessage='Выполняйте специальные задачи и получайте различные элементы внешнего вида, а также другие награды. Развивайте Укрепрайон и пользуйтесь клановыми резервами, дающими бонусы к опыту и кредитам.'
    />
)



// WEBPACK FOOTER //
// ./containers/Landing/components/LandingBonus/constants.jsx